import { AgsResultBuilder } from "ags/integration/builders/results/abstract-ags-result-builder";
import { PretellResult } from "ags/integration/model/results/pretell-result";
import { AgsEvent } from "ags/integration/schema/ags-spin-response-schema";
import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";

export class PretellResultBuilder extends AgsResultBuilder implements ResultBuilder {
    public filter(data: any): boolean {
        const event = data as AgsEvent;
        return event.id && event.id.toLowerCase() === "pretell";
    }

    public build(record: Record, data: any): Result[] {
        const event = data as AgsEvent;

        const result = new PretellResult();
        result.animationType = event.animationType;

        return [result];
    }
}
